<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  max-width: 400px;
  margin: 0 auto;
}
.bakc-bont{
  width: 100%;
  max-width:400px;
  left: auto!important;
  right: auto!important;
}
.back-bont{
  max-width:400px;
  left: auto!important;
  right: auto!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue